import axiosClient from "../apiClient";

export const getCoupons = async () => {
  return await axiosClient.get(`admin/coupons`);
};

export const createCoupon = async (data) => {
  return await axiosClient.post(`admin/coupons`, data);
};

export const toggleCouponStatus = async (couponId) => {
  return await axiosClient.patch(`admin/coupons/${couponId}/status`);
};

export const getCouponRedemptions = async (couponId) => {
  return await axiosClient.get(`admin/coupons/${couponId}/redemptions`);
};

export const revokeRedemption = async (redemptionId) => {
  return await axiosClient.post(`admin/coupons/redemptions/${redemptionId}/revoke`);
};
